
export default function Services() {
  const services = [
    {
      icon: 'ri-calendar-event-line',
      title: 'Producción de Eventos',
      description: 'Organizamos eventos corporativos, bodas, fiestas privadas y conciertos con la más alta calidad profesional. Nos encargamos de cada detalle para que tu evento sea inolvidable.'
    },
    {
      icon: 'ri-mic-line',
      title: 'Artistas y Grupos Musicales',
      description: 'Contamos con los mejores artistas, cantantes y grupos musicales de diversos géneros. Desde música regional mexicana hasta pop, rock y más. Talento garantizado para tu evento.'
    },
    {
      icon: 'ri-volume-up-line',
      title: 'Renta de Sonido Profesional',
      description: 'Equipos de audio de última generación para eventos de cualquier tamaño. Sistemas de sonido profesional, iluminación escénica y efectos especiales con técnicos especializados.'
    },
    {
      icon: 'ri-music-2-line',
      title: 'Estudio de Grabación',
      description: 'Estudio profesional equipado con tecnología de punta para grabación, mezcla y masterización. Producción musical completa con ingenieros de sonido experimentados.'
    },
    {
      icon: 'ri-team-line',
      title: 'Asesoría Personalizada',
      description: 'Te acompañamos en todo el proceso de planificación de tu evento. Nuestro equipo de expertos te brinda soluciones creativas adaptadas a tu presupuesto y necesidades.'
    },
    {
      icon: 'ri-star-line',
      title: 'Calidad Garantizada',
      description: 'Más de 15 años de experiencia en la industria del entretenimiento. Compromiso total con la excelencia y satisfacción de nuestros clientes en cada proyecto.'
    }
  ];

  return (
    <section id="servicios" className="py-24 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="font-['Montserrat',sans-serif] text-4xl sm:text-5xl font-bold text-gray-900 mb-4">
            Nuestros Servicios
          </h2>
          <p className="font-['Poppins',sans-serif] text-base text-gray-600 max-w-2xl mx-auto">
            Ofrecemos soluciones integrales para hacer de tu evento una experiencia única e inolvidable
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div 
              key={index}
              className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 border border-gray-100"
            >
              <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-br from-teal-500 to-teal-600 rounded-2xl mb-6 shadow-lg">
                <i className={`${service.icon} text-3xl text-white w-8 h-8 flex items-center justify-center`}></i>
              </div>
              <h3 className="font-['Montserrat',sans-serif] text-xl font-bold text-gray-900 mb-3">
                {service.title}
              </h3>
              <p className="font-['Poppins',sans-serif] text-sm text-gray-600 leading-relaxed">
                {service.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
